import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FilterConstant } from 'src/app/core/constants/filter.const';
import { LocalStorageService } from 'src/app/core/services/localStorage/localStorage.service';

@Component({
  selector: 'app-filter-tag-list',
  templateUrl: './filter-tag-list.component.html',
  styleUrls: ['./filter-tag-list.component.scss'],
  standalone: true,
  imports: [CommonModule, MatChipsModule, MatTooltipModule, MatIconModule]
})
export class FilterTagListComponent {
  @Input() filtersTagList: any = [];
  @Input() filterKey: string = '';
  @Output() onRemoveControl: EventEmitter<any> = new EventEmitter()

  constructor(private _localStorageService: LocalStorageService) { }

  resetIndiviualFilter(i: number) {
    this.filtersTagList.splice(i, 1);
    this._localStorageService.setSessionKey(FilterConstant[this.filterKey], JSON.stringify(this.filtersTagList));
    this.onRemoveControl.emit();

    // this.selectedFiltersTagList.splice(i, 1);
    // this.application_filter_form.get(controlName).setValue('');
    // const removedData = this.selectedFiltersTagList.splice(i, 1);
    // if (removedData) {
    //   const formControl = Object.keys(removedData[0]);
    // }
    // this.applyFilter();
  }
}
